import React from "react";
import Button, { ButtonType } from "../Assets/Button";

interface AddRoundOffModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  customerName: string;
  roundOffAmount: number;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

const AddRoundOffModal: React.FC<AddRoundOffModalProps> = ({
  isOpen,
  isLoading = false,
  customerName,
  roundOffAmount,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Confirm Round Off (
          <span className="font-semibold text-purple-600">
            ₹{roundOffAmount.toLocaleString("en-IN")}
          </span>
          )
        </h3>

        <p className="text-sm text-gray-600 mb-4">
          Are you sure you want to apply round-off adjustment for
          <span className="font-medium text-gray-900"> {customerName}</span>?
        </p>

        <div className="flex justify-end gap-3">
          <Button
            type={ButtonType.Cancel}
            onClick={onClose}
            className="text-xs"
            disabled={isLoading}
          >
            Cancel
          </Button>

          <Button
            type={ButtonType.Extra}
            onClick={onConfirm}
            disabled={isLoading}
            className="text-xs"
          >
            {isLoading ? "Processing..." : "Confirm"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddRoundOffModal;
